(() => {
  const signup = document.querySelector('[data-lac-cart-email]');
  if (!signup) return;
  let pending = false;
  function mount() {
    pending = false;
    const cart = document.getElementById('rebuy-cart');
    if (!cart) return;
    const previous = cart.querySelector('[data-rebuy-app-id="32"]');
    const footer = cart.querySelector('[data-rebuy-cart-anchor="footer"]');
    if (previous && signup.nextElementSibling !== previous) {
      previous.before(signup);
    } else if (!previous && footer && signup.parentElement !== footer) {
      footer.prepend(signup);
    }
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(mount);
  }
  document.addEventListener('rebuy:smartcart.ready', schedule);
  document.addEventListener('rebuy:smartcart.show', schedule);
  document.addEventListener('rebuy:cart.change', schedule);
  schedule();
})();
